import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

type VipStatusResponse = {
  isVip: boolean;
};

export function useVipStatus(tenantId?: string, enabled = true) {
  return useQuery({
    queryKey: ['vipStatus', tenantId],
    queryFn: () =>
      apiClient<VipStatusResponse>(
        `/users/me/vip-status${tenantId ? `?tenantId=${tenantId}` : ''}`
      ),
    enabled: enabled && !!tenantId,
  });
}
